export enum MeasureEditorViewSection {
    Demographics = 'Demographics',
    Measures = 'Measures',
    Suspect = 'Suspect',
    Chronic = 'Chronic',
    Diagnosis = 'Diagnosis'
}